/* Nuvie landing page (nvg-*) behaviours: gallery, carousels, timers, sticky bar. */
(function(){
  function each(sel, root, fn){ Array.prototype.forEach.call((root||document).querySelectorAll(sel), fn); }
  function once(el){ if (el.getAttribute('data-g-ready')) return false; el.setAttribute('data-g-ready','1'); return true; }

  function gallery(root){
    each('[data-g-gal]', root, function(g){
      if (!once(g)) return;
      var track = g.querySelector('.g-gal-track'), thumbs = g.querySelectorAll('.g-thumb');
      if (!track) return;
      function idx(){ return Math.round(track.scrollLeft / track.clientWidth); }
      function go(i){ var n = track.children.length; i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
      function mark(){ var i = idx(); Array.prototype.forEach.call(thumbs, function(t, k){ t.classList.toggle('is-on', k === i); }); }
      Array.prototype.forEach.call(thumbs, function(t, k){ t.addEventListener('click', function(){ go(k); }); });
      var p = g.querySelector('.g-arrow--prev'), n = g.querySelector('.g-arrow--next');
      if (p) p.addEventListener('click', function(){ go(idx() - 1); });
      if (n) n.addEventListener('click', function(){ go(idx() + 1); });
      var t; track.addEventListener('scroll', function(){ clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
      mark();
    });
  }

  function carousels(root){
    each('[data-g-car]', root, function(c){
      if (!once(c)) return;
      var track = c.querySelector('.g-car-track');
      if (!track) return;
      function step(dir){ var card = track.firstElementChild; var w = card ? card.getBoundingClientRect().width + 16 : track.clientWidth; track.scrollBy({ left: dir * w, behavior: 'smooth' }); }
      var p = c.querySelector('.g-arrow--prev'), n = c.querySelector('.g-arrow--next');
      if (p) p.addEventListener('click', function(){ step(-1); });
      if (n) n.addEventListener('click', function(){ step(1); });
    });
  }

  function timers(root){
    each('[data-g-timer]', root, function(el){
      if (!once(el)) return;
      var mins = parseInt(el.getAttribute('data-minutes'), 10) || 15, key = 'nvg-t-' + (el.getAttribute('data-key') || 'x'), end;
      try { end = parseInt(sessionStorage.getItem(key), 10); } catch (e) {}
      if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, end); } catch (e) {} }
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function pad(x){ return (x < 10 ? '0' : '') + x; }
      function tick(){
        var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (left === 0) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, end); } catch (e) {} }
        if (h) h.textContent = pad(Math.floor(left / 3600));
        if (m) m.textContent = pad(Math.floor(left % 3600 / 60));
        if (s) s.textContent = pad(left % 60);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  function sticky(root){
    each('[data-g-sticky]', root, function(bar){
      if (!once(bar)) return;
      var offset = parseInt(bar.getAttribute('data-offset'), 10) || 700, mobileOnly = bar.getAttribute('data-mobile') === 'true';
      function update(){
        var on = window.scrollY > offset && (!mobileOnly || window.innerWidth < 750);
        each('[data-g-hide-sticky]', document, function(z){ var r = z.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) on = false; });
        bar.classList.toggle('is-on', on);
      }
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function smooth(root){
    each('.nvg a[href^="#"]', root, function(a){
      if (a.getAttribute('data-g-smooth')) return; a.setAttribute('data-g-smooth', '1');
      a.addEventListener('click', function(e){
        var id = a.getAttribute('href').slice(1); if (!id) return;
        var cfg = document.querySelector('[data-g-cta-target]');
        var mode = cfg ? cfg.getAttribute('data-g-cta-target') : 'top';
        if (id === 'top' || (id === 'packages' && mode === 'top')) {
          e.preventDefault();
          var bx = document.querySelector('.g-bx');
          if (bx) { window.scrollTo({ top: Math.max(0, bx.getBoundingClientRect().top + window.scrollY - 16), behavior: 'smooth' }); }
          else { window.scrollTo({ top: 0, behavior: 'smooth' }); }
          return;
        }
        var t = document.getElementById(id); if (!t) return;
        e.preventDefault(); window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 10, behavior: 'smooth' });
      });
    });
  }

  function init(root){ gallery(root); carousels(root); timers(root); sticky(root); smooth(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

/* Bundle ATC: empty the cart before adding a bundle so repeat taps / back-button don't stack bundles at checkout */
(function(){
  if (window.__bxClearPatch) return; window.__bxClearPatch = 1;
  var armed = false, of = window.fetch;
  if (!of) return;
  document.addEventListener('click', function(e){ if (e.target && e.target.closest && e.target.closest('[data-bx-atc]')) armed = true; }, true);
  window.fetch = function(u, o){
    try {
      var url = typeof u === 'string' ? u : (u && u.url) || '';
      if (armed && url.indexOf('/cart/add') !== -1) {
        armed = false;
        var a = arguments, self = this;
        return of.call(window, '/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
          .catch(function(){})
          .then(function(){ return of.apply(self, a); });
      }
    } catch (err) {}
    return of.apply(this, arguments);
  };
})();
